import React, { ForwardedRef, forwardRef, ReactElement } from 'react';
import { colors } from '../../../../colors';
import { FaArrowLeft, FaCheck } from 'react-icons/fa';

interface Props {
  index: number;
  title: string;
  children?: ReactElement;
  isActive: boolean;
  isFinished?: boolean;
  handleBackPress?: () => void;
}

const Card = forwardRef(
  (
    { index, title, children, isActive, isFinished, handleBackPress }: Props,
    ref: ForwardedRef<HTMLDivElement>,
  ) => {
    return (
      <div
        ref={ref}
        style={{
          flex: '0 0 auto',
          height: '100%',
          borderBottom: '3px solid gray',
          borderLeft: isActive ? '3px solid gray' : undefined,
          minWidth: isFinished ? '80vw' : '50vw',
          maxWidth: isFinished ? '80vw' : '65vw',
          position: 'relative',
          borderBottomLeftRadius: 16,
          display: 'flex',
          flexDirection: 'column',
          zIndex: 60,
          marginLeft: -10,
          ...(!isActive && {
            opacity: 0.2,
            marginLeft: 45,
            borderBottomLeftRadius: 0,
            zIndex: 50,
          }),
          transition: 'opacity 0.5s ease',
          overflowY: isActive ? 'clip' : undefined,
        }}
      >
        <div
          style={{
            width: 80,
            height: 80,
            borderRadius: 40,
            border: '5px solid gray',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: colors.black,
            position: 'absolute',
            left: -45,
            color: colors.white,
            fontSize: 40,
            fontWeight: 'bold',
            top: isActive ? 0 : undefined,
            bottom: isActive ? undefined : -45,
          }}
        >
          {isFinished ? <FaCheck size={32} color={colors.white} /> : index}
        </div>
        {handleBackPress && (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              position: 'absolute',
              left: -95,
              top: isActive ? 29 : undefined,
              cursor: 'pointer',
            }}
            onClick={handleBackPress}
          >
            {isActive ? <FaArrowLeft size={32} color={colors.gray} /> : null}
          </div>
        )}
        <p
          style={{
            color: colors.white,
            margin: 0,
            fontSize: 28,
            marginTop: 23,
            paddingLeft: 60,
            opacity: isActive ? 1 : 0,
            transition: 'opacity 0.5s ease',
          }}
        >
          {title}
        </p>
        <div
          style={{
            flex: 1,
            display: 'flex',
            height: '100%',
            maxHeight: '100%',
            marginTop: 23,
            padding: 30,
            opacity: isActive ? 1 : 0,
            transition: 'opacity 0.5s ease',
            overflowY: 'auto',
            marginRight: isFinished ? 0 : 100,
          }}
        >
          {children}
        </div>
      </div>
    );
  },
);

Card.displayName = 'Card';

export default Card;
